<div class="flex flex-row items-stretch justify-center m-auto gap-2">
    <div class="flex flex-row gap-2 items-center">
        <app-button
            [disabled]="selectionService.selectedLayerIds().length > 0"
            [htmlType]="'button'"
            [icon]="['far', 'draw-polygon']"
            [iconSize]="'sm'"
            [tooltip]="'drawPolygon' | transloco"
            [type]="mapDrawService.isPolygonDrawSessionActive() ? ButtonType.PRIMARY : ButtonType.SECONDARY"
            (click)="selectionService.toggleDrawPolygon()" />

        <app-button
            [htmlType]="'button'"
            [icon]="['fas', 'hexagon']"
            [iconSize]="'lg'"
            [tooltip]="'selectPolygonLayer' | transloco"
            [type]="
                selectionService.selectionMode() === FilterModeEnum.SELECT_ZONE
                    ? ButtonType.PRIMARY
                    : ButtonType.SECONDARY
            "
            (click)="toggleSelectLayer()" />

        <app-select
            [canClear]="true"
            [clearSelection]="selectionService.mapClearSelectedLayer()"
            [isDisabled]="selectionService.selectionMode() !== FilterModeEnum.SELECT_ZONE"
            [isMultiSelect]="false"
            [isSimpleSelectStyle]="true"
            [label]="''"
            [options]="selectionService.polygonLayerOptions()"
            [placeholder]="'selectLayer'"
            [sortOptions]="true"
            (selectedOptionsChange)="onLayerGroupChange($event)" />

        <app-button
            [disabled]="!mapDrawService.hasDrawnPolygon() && !selectionService.selectedLayerIds().length"
            [htmlType]="'button'"
            [icon]="['fas', 'trash']"
            [iconSize]="'sm'"
            [tooltip]="'removeSelections' | transloco"
            [type]="ButtonType.ALERT_SECONDARY"
            (click)="selectionService.clearAllSelections(false, ModeUiSource.MAP)" />

        <app-button
            [disabled]="!mapDrawService.hasDrawnPolygon() && !selectionService.selectedLayerIds().length"
            [htmlType]="'button'"
            [icon]="['fas', 'check']"
            [iconSize]="'sm'"
            [type]="ButtonType.SECONDARY"
            (click)="selectionService.apply()" />
    </div>
</div>
